import { storeToRefs } from 'pinia';
import { AppCoreEnums } from '../shared/enums';
import { useCoreStore } from '../../stores/core/store';

export default () => {
  const { confirmationDialogData } = storeToRefs(useCoreStore());

  const showConfirmation = (msg: string, title: string | undefined = 'core.confirmation', showCancel = false) => {
    confirmationDialogData.value.message = msg;
    confirmationDialogData.value.title = title;
    confirmationDialogData.value.showNegative = false;
    confirmationDialogData.value.showCancel = showCancel;
    confirmationDialogData.value.isDeleteConfirmation = false;
    confirmationDialogData.value.negativeLabel = 'core.no';
    confirmationDialogData.value.positiveLabel = 'core.yes';

    var promise = new Promise<AppCoreEnums.ConfirmationResult>((resolve) => {
      confirmationDialogData.value.resolveFn = resolve;
      confirmationDialogData.value.isVisible = true;
    });

    return promise;
  };

  const showDeleteConfirmation = (msg: string, title: string | undefined = 'core.confirmation', showCancel = false) => {
    confirmationDialogData.value.message = msg;
    confirmationDialogData.value.title = title;
    confirmationDialogData.value.showNegative = false;
    confirmationDialogData.value.negativeLabel = 'core.cancel2';
    confirmationDialogData.value.positiveLabel = 'core.delete';
    confirmationDialogData.value.showCancel = showCancel;
    confirmationDialogData.value.isDeleteConfirmation = true;

    var promise = new Promise<AppCoreEnums.ConfirmationResult>((resolve) => {
      confirmationDialogData.value.resolveFn = resolve;
      confirmationDialogData.value.isVisible = true;
    });

    return promise;
  };

  const showYesNoConfirmation = (msg: string, title: string | undefined = 'core.confirmation') => {
    confirmationDialogData.value.message = msg;
    confirmationDialogData.value.title = title;
    confirmationDialogData.value.showNegative = true;
    confirmationDialogData.value.showCancel = false;

    var promise = new Promise<AppCoreEnums.ConfirmationResult>((resolve) => {
      confirmationDialogData.value.resolveFn = resolve;
      confirmationDialogData.value.isVisible = true;
    });

    return promise;
  };

  return {
    showConfirmation,
    showYesNoConfirmation,
    showDeleteConfirmation
  };
};
